/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ContractReviewer = {
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    cpf: {
      type: 'string',
      isRequired: true,
    },
    birthDate: {
      type: 'string',
      isRequired: true,
      format: 'date',
    },
    email: {
      type: 'string',
      isRequired: true,
    },
    role: {
      type: 'string',
      isRequired: true,
    },
    userId: {
      type: 'string',
    },
    approvalCompetencyId: {
      type: 'string',
    },
    type: {
      type: 'ContractReviewerType',
      isRequired: true,
    },
  },
} as const;
